<template>
  <div class="page-container">
    <!--内容-->
    <div class="booksearchCon pt-200  pb-100">
      <!--面包屑导航-->
      <Breadcrumb :breadcrumbList="['书目下载']"></Breadcrumb>
      <!--title-->
      <div class="resulttit mt-90 flex ai-center">
        <span class="ml-30 fs-20 color-fontcol4">高级查询</span>
      </div>
      <!--高级查询-->
      <div class="screencon flex ai-center mt-20">
        <span class="fs-18 color-fontcol3 ml-30">出版年月 :</span>
        <input
          class="ml-20"
          type="number"
          placeholder="年"
          :value="year"
          @input="watchyear"
        />
        <div class="dline ml-20 mr-20"></div>
        <input type="number" :value="month" placeholder="月" @input="watchmonth" />
        <span class="fs-16 color-fontcol3 ml-60">作者 :</span>
        <input class="ml-20" type="text" :value="auctor" @input="watchactor" />
        <span class="fs-16 color-fontcol3 ml-60">书目分类 :</span>
        <!-- <input
          class="ml-20"
          type="number"
          placeholder="图书分类id"
          :value="booktype"
          @input="watchtype"
        /> -->
        <div class="changeDiv ml-20">
          <input
            id="booktype"
            type="text"
            list="booktypelist"
            v-model="bookname"
            @change="chosetypeid"
          />
          <datalist id="booktypelist">
            <option
              v-for="(item, index) in booktypelist"
              :key="index"
              :value="item.name"
            ></option>
          </datalist>
        </div>
        <button
          class="btn-search bg-primary ml-40 color-white fs-16 point"
          @click="getdownloadlist"
        >
          查询
        </button>
      </div>
      <!--下载按钮-->
      <div class="downloadbth mt-20 pb-20">
        <div class="btn text-center color-white fs-18 point" @click="download()">
          下载
        </div>
      </div>
      <!--搜索结果con-->
      <div>
        <div
          class="resultcon"
          v-for="(item, key, index) in searchlist"
          :key="index"
        >
          <div class="bg-primary fs-20 color-white text-center py-20">{{ key }}</div>
          <table v-for="(items, index) in item" :key="index">
            <thead>
              <tr class="bg-colebf3fc">
                <th class="fs-18 color-fontcol3 text-center">
                  {{ items.columnName }}
                </th>
              </tr>
              <tr class="title fs-18 color-fontcol3 flex jc-betweet">
                <th class="text-center threeth">序号</th>
                <th class="text-center threeth">书号</th>
                <th class="text-left bg-colf5">书名</th>
                <th class="text-left">作者</th>
                <th class="text-right">定价</th>
                <th class="text-center">出版年月</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="fs-16 color-fontcol3 flex jc-betweet"
                v-for="(info, idx) in items.zxBook"
                :key="idx"
              >
                <td class="text-center color-primary text-ellipsis threetd">
                  {{ idx + 1 }}
                </td>
                <td class="text-center text-ellipsis threetd">{{ info.isbn }}</td>
                <td class="text-left bg-colf5 text-ellipsis">{{ info.title }}</td>
                <td class="text-left text-ellipsis">{{ info.author }}</td>
                <td class="text-center text-right">¥ {{ info.price.toFixed(2) }}</td>
                <td class="text-center text-ellipsis">{{ info.publishTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/common/breadcrumb";
export default {
  name: "bookdownload",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      year: "", //出版年
      month: "", //出版月
      auctor: "", //作者
      booktype: "", //图书分类
      bookname: "", //分类名称
      booktypelist: [], //图书分类列表
      searchlist: [],
    };
  },
  mounted() {
    this.getdownloadlist();
    this.getnavs();
  },
  methods: {
    //获取图书分类
    async getnavs() {
      var res = await this.$API.API_Ajax("侧面导航列表", {
        type: this.CONSTANT.getDateByCode("nav_classid").id,
      });
      if (res.code == 200) {
        this.booktypelist = res.data;
      }
    },
    //年
    watchyear(e) {
      var val = e.currentTarget.value;
      this.year = val >= 0 ? val : 0;
    },
    //月
    watchmonth(e) {
      var val = e.currentTarget.value;
      this.month = val >= 0 ? val : 0;
    },
    //图书分类
    chosetypeid() {
      this.booktypelist.map((item) => {
        if (item.name == this.bookname) {
          this.booktype = item.id;
        }
      });
    },
    //作者
    watchactor(e) {
      this.auctor = e.currentTarget.value;
    },
    //获取详情
    async getdownloadlist() {
      var res = await this.$API.API_Ajax("书目下载列表", {
        columnId: this.booktype,
        author: this.auctor,
        year: this.year,
        month: this.month,
      });
      if (res.code == 200) {
        this.searchlist = res.data;
      }
    },
    //下载
    async download() {
      var href =
        "http://www.cctpress.com/api/book/load?columnId=" +
        this.booktype +
        "&author=" +
        this.auctor +
        "&year=" +
        this.year +
        "&month=" +
        this.month;
      console.log(href);
      window.location.href = href;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: auto;
  margin: auto;
  .booksearchCon {
    width: 65%;
    height: auto;
    margin: auto;
    .screencon {
      height: 60px;
      border-bottom: 1px solid #e4e4e4;
      input {
        width: 137px;
        height: 20px;
        border: 1px solid #dadada;
        padding: 5px;
      }
      .dline {
        width: 20px;
        height: 1px;
        background: #dadada;
      }
      .changeDiv {
        input {
          width: 137px;
          height: 20px;
          border: 1px solid #dadada;
          padding: 5px;
        }
      }
    }
    .downloadbth {
      width: 100%;
      overflow: hidden;
      .btn {
        width: 126px;
        height: 42px;
        line-height: 42px;
        background: #3b8ce0;
        border-radius: 5px;
        float: right;
      }
    }
    .resulttit {
      height: 70px;
      background: #f5f5f5;
      border: 1px solid #ededed;
    }
    .resultcon {
      width: 100%;
      table {
        width: 100%;
        thead {
          width: 100%;
          tr {
            width: 100%;
            th {
              width: 100%;
              height: 60px;
              line-height: 60px;
            }
          }
          tr.title {
            width: 100%;
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #e2e2e2;
            th {
              width: 14.2%;
              height: 40px;
              line-height: 40px;
              padding: 0 10px;
            }
            th.threeth {
              width: 6.2%;
              height: 40px;
              line-height: 40px;
              padding: 0 10px;
            }
            th:nth-child(3) {
              width: 30%;
              padding: 0 10px;
            }
          }
        }
        tbody {
          width: 100%;
          tr {
            width: 100%;
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #e2e2e2;
            td {
              width: 14.2%;
              height: 40px;
              line-height: 40px;
              padding: 0 10px;
            }
            td.threetd {
              width: 6.2%;
              height: 40px;
              line-height: 40px;
              padding: 0 10px;
            }
            td:nth-child(3) {
              width: 30%;
              padding: 0 10px;
            }
          }
        }
      }
    }
  }
}
</style>
